import React from 'react';
import PropTypes from 'prop-types';

import style from './style.module.scss';

export function Header(props) {
  return (
    <p className={`${style.sliderHeader} ${props.className} `}>
      {props.text}
    </p>
  );
}

Header.propTypes = {
  /**
   * classname
   */
  className: PropTypes.string,
  /**
   * text to be displayed in header
   */
  text: PropTypes.string,
};
